import ls from 'local-storage'

import { hideData } from './hideData'

export const populateLocalStorage = (data) => {
    ls.clear()
    ls.set('user_uid', data.uid)
    ls.set('role_uid', data.role_uid)
    ls.set('firstname', data.firstname)
    ls.set('middlename', data.middlename)
    ls.set('lastname', data.lastname)
    ls.set('id', hideData({ authenticated: true }))
}

export const clearLocalStorage = () => {
    ls.clear()
}